import { combineReducers } from 'redux'
import languageReducer from '../language/reducers'

const root = combineReducers({
  languageReducer,
})

export default root
